<template>
  <q-dialog v-model="_show" persistent>
    <q-card-section class="paying line-height-120">
      <q-circular-progress
        :thickness="0.25"
        indeterminate
        size="40px"
        color="primary"
      />
      <div class="text-weight-bolder font-size-16 q-pt-sm">
        <span>{{ $t('componentsBaseDialog.paying') }}</span>
      </div>
      <div class="text-theme-gray font-size-12 q-pt-xs">
        <span>{{ $t('componentsBaseDialog.payingMsg') }}</span>
      </div>
    </q-card-section>
  </q-dialog>
</template>
<script setup>
import { defineProps, computed, defineEmits } from 'vue';

const emits = defineEmits(['input']);
const props = defineProps({
  value: Boolean,
});
const _show = computed({
  get() {
    return props.value;
  },
  set(v) {
    emits('input', v);
  },
});
</script>
<style scoped lang="scss">
.paying {
  width: 80%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
